(function () {

    'use strict';

    angular.module('Services')
        .factory('ClientService', function ($http, $rootScope, Error, Request) {
            return {
                Reseller: {
                    getAll: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.client.adminReseller + '/all',
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data,
                            disableResellerFilter: true
                        })
                    },
                    getAllRoot: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.client.adminReseller + '/root',
                            //url: ApiURLs.client.company,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data,
                            disableResellerFilter: true
                        })
                    },
                    enableToNetworkEffect: function (ids, successCallback, errorCallback) {
                        Request.post({
                            url: ApiURLs.client.adminReseller + '/enable',
                            method: 'POST',
                            successCallback: successCallback,
                            errorCallback: errorCallback,
                            disableResellerFilter: true
                        }, ids);
                    },
                    disableToNetworkEffect: function (ids, successCallback, errorCallback) {
                        Request.post({
                            url: ApiURLs.client.adminReseller + '/disable',
                            method: 'POST',
                            successCallback: successCallback,
                            errorCallback: errorCallback,
                            disableResellerFilter: true
                        }, ids);
                    }
                },
                Client: {
                    getAll: function (callback, errCallback, data, params = {}) {
                        Request.get(angular.extend({
                            url: ApiURLs.client.list,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        }, params));
                    },
                    get: function (id, callback, errCallback) {
                        Request.get({
                            url: ApiURLs.client.list + '/' + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    update: function (data, callback, errCallback, id) {
                        Request.post({
                            method: 'PUT',
                            url: ApiURLs.client.list + '/' + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        }, data);
                    },
                    getBilling: function (successCallback, errorCallback) {
                        Request.get({
                            url: ApiURLs.client.getBilling,
                            method: 'GET',
                            successCallback: successCallback,
                            errorCallback: errorCallback
                        });
                    },
                    sendPreview: function (data, successCallback, errorCallback, id) {
                        Request.post({
                            method: 'POST',
                            url: `${ApiURL}carrier/admin/client-service/${id}/preview`,
                            successCallback: successCallback,
                            errorCallback: errorCallback
                        }, data);
                    },
                    getHistory: function (successCallback, errorCallback, id) {
                        Request.get({
                            url: `${ApiURL}carrier/admin/client-service/${id}/preview`,
                            method: 'GET',
                            successCallback: successCallback,
                            errorCallback: errorCallback
                        });
                    },
                    getAvailableCompany: function (successCallback, errorCallback, data) {
                        Request.get({
                            url: ApiURLs.client.companyAvailable,
                            method: 'GET',
                            successCallback: successCallback,
                            errorCallback: errorCallback,
                            cache: true,
                            data: data
                        });
                    },
                    getAvailableOffice: function (successCallback, errorCallback, data) {
                        Request.get({
                            url: ApiURLs.client.officeAvailable,
                            method: 'GET',
                            successCallback: successCallback,
                            errorCallback: errorCallback,
                            cache: true,
                            data: data
                        });
                    },
                    payloadMapper: function (payload, isBreakBulk) {
                        function getPickupDays(frequency) {
                            return Object.keys(frequency).filter(key => frequency[key]);
                        }

                        function getPickupTime(pickupTimeValue) {
                            return `${pickupTimeValue.hour}:${pickupTimeValue.min}`;
                        }

                        function getCutoff(cutoffValue) {
                            return `${cutoffValue.hour}:${cutoffValue.min}`;
                        }

                        const {
                            carrierProfile,
                            serviceProfile,
                            officeId,
                            frequency,
                            pickupTimeValue,
                            cutoffValue,
                            firstMile,
                            lastMile,
                            daysBeforeLastMilePickup
                        } = payload;

                        if (!isBreakBulk) {
                            return {
                                carrierProfileId: carrierProfile.id,
                                serviceProfileId: serviceProfile.id,
                                officeId: officeId,
                                cutoff: getCutoff(cutoffValue),
                                pickupDays: getPickupDays(frequency),
                                pickupTime: getPickupTime(pickupTimeValue),
                            };
                        }

                        return {
                            carrierProfileId: carrierProfile.id,
                            serviceProfileId: serviceProfile.id,
                            officeId: officeId,
                            daysBeforeLastMilePickup: angular.getObjVal(daysBeforeLastMilePickup, 'value'),

                            firstMileCutoff: getCutoff(firstMile.cutoffValue),
                            firstMilePickupDays: getPickupDays(firstMile.frequency),
                            firstMilePickupTime: getPickupTime(firstMile.pickupTimeValue),

                            lastMileCutoff: getCutoff(lastMile.cutoffValue),
                            lastMilePickupDays: getPickupDays(lastMile.frequency),
                            lastMilePickupTime: getPickupTime(lastMile.pickupTimeValue)
                        }
                    }
                },
                Company: {
                    getAll: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.client.company,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    },
                    get: function (id, callback, errCallback) {
                        Request.get({
                            url: ApiURLs.client.company + '/' + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    create: function (data, callback, errCallback) {
                        Request.post({
                            method: 'POST',
                            url: ApiURLs.client.company,
                            successCallback: callback,
                            errorCallback: errCallback
                        }, data);
                    },
                    update: function (data, callback, errCallback, id) {
                        Request.post({
                            method: 'PUT',
                            url: ApiURLs.client.company + '/' + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        }, data);
                    },
                    enable: function (id, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.client.company + '/' + id + '/enable',
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    disable: function (id, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.client.company + '/' + id + '/disable',
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    validateEmail: function (payload, successCallback, errorCallback) {
                        Request.post({
                            url: ApiURLs.client.company + '/email-validation',
                            method: 'POST',
                            successCallback: successCallback,
                            errorCallback: errorCallback
                        }, payload);

                    },
                    uploadLogo: function (file, companyId, callback, errCallback) {
                        Request.upload({
                            url: ApiURLs.client.company + '/' + companyId + '/logo',
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback,
                            fileKey: 'file',
                            /*headers: {
                                'Accept': 'plain/text'
                            }*/
                        }, file);
                    },
                    uploadLogoEmail: function (file, companyId, senderEmail, callback, errCallback) {
                        const url = ApiURLs.client.company + '/' + companyId + '/configure-email?senderEmail=' + senderEmail;
                        Request.upload({
                            url: url,
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback,
                            fileKey: 'file',
                            /*headers: {
                                'Accept': 'plain/text'
                            }*/
                        }, file);
                    },
                    removeLogo: function (companyId, callback, errCallback) {
                        const url = ApiURLs.client.company + '/' + companyId + '/email-logo';
                        Request.delete({
                            url: url,
                            method: 'DELETE',
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    hideDetails: function (companyId, isHidden, successCallback, errorCallback) {
                        const url = ApiURLs.client.hideReceiverDetails.replace(':id', companyId).replace(':status', isHidden);
                        Request.post({
                            url: url,
                            method: 'PUT',
                            successCallback: successCallback,
                            errorCallback: errorCallback
                        });
                    },
                    hideDetailsAdmin: function (companyId, isHidden, successCallback, errorCallback) {
                        const url = ApiURLs.client.hideReceiverDetailsAdmin.replace(':id', companyId).replace(':status', isHidden);
                        Request.post({
                            url: url,
                            method: 'PUT',
                            successCallback: successCallback,
                            errorCallback: errorCallback
                        });
                    },
                    cleanPayload: function (data) {
                        const {
                            name,
                            location,
                            id,
                            enableServiceSharing,
                            networkEnabled,
                            email,
                            phone1,
                            phone2,
                            billingProfile,
                            primaryContact,
                            addressLine1,
                            addressLine2,
                            website,
                            resellerId,
                            active,
                            logoUrl,
                            isReseller,
                            smsNotificationEnabled
                        } = data;
                        return {
                            name,
                            "location": location.id,
                            id,
                            enableServiceSharing,
                            networkEnabled,
                            email,
                            phone1,
                            phone2,
                            billingProfile: angular.extend(angular.copy(billingProfile), {
                                location: billingProfile.location.id
                            }),
                            primaryContact,
                            addressLine1,
                            addressLine2,
                            website,
                            resellerId,
                            active,
                            logoUrl,
                            isReseller,
                            smsNotificationEnabled
                        };
                    }
                },
                Location: {
                    getAll: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.client.location,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    },
                    /*As per Zulfy, this gets office by ID*/
                    get: function (data, callback, errCallback) {
                        Request.get({
                            url: ApiURLs.client.location + '/' + data['company.id'],
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    },

                    /*Get office by Company*/
                    getByCompany: function (data, callback, errCallback) {
                        Request.get({
                            url: ApiURLs.client.location,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    },
                    create: function (data, callback, errCallback) {
                        Request.post({
                            method: 'POST',
                            url: ApiURLs.client.location,
                            successCallback: callback,
                            errorCallback: errCallback
                        }, data);
                    },
                    update: function (data, callback, errCallback, id) {
                        Request.post({
                            method: 'PUT',
                            url: ApiURLs.client.location + '/' + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        }, data);
                    },
                    enable: function (id, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.client.location + '/' + id + '/enable',
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    disable: function (id, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.client.location + '/' + id + '/disable',
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    getPickupSchedules: function (id, successCallback, errorCallback, filters) {
                        const url = id ? `${ApiURLs.client.pickupSchedules}/office/${id}` : ApiURLs.client.pickupSchedules;
                        Request.get({
                            url: url,
                            successCallback,
                            errorCallback,
                            data: filters
                        })
                    },
                    createPickupSchedules: function (successCallback, errorCallback, data) {
                        Request.post({
                            method: 'POST',
                            url: `${ApiURLs.client.pickupSchedules}`,
                            successCallback,
                            errorCallback
                        }, data)
                    },
                    updatePickupSchedules: function (id, successCallback, errorCallback, data) {
                        Request.post({
                            method: 'PUT',
                            url: `${ApiURLs.client.pickupSchedules}/${id}`,
                            successCallback,
                            errorCallback
                        }, data)
                    },
                    deletePickupSchedule: function (id, successCallback, errorCallback) {
                        Request.delete({
                            url: `${ApiURLs.client.pickupSchedules}/${id}`,
                            successCallback,
                            errorCallback
                        })
                    },
                    deleteOffice: function (id, successCallback, errorCallback) {
                        Request.delete({
                            url: `${ApiURLs.client.location}/${id}`,
                            successCallback,
                            errorCallback
                        });
                    }
                },
                Group: {
                    getAll: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.client.group,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    },
                    get: function (id, callback, errCallback) {
                        Request.get({
                            url: ApiURLs.client.group + '/' + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    create: function (data, callback, errCallback) {
                        Request.post({
                            method: 'POST',
                            url: ApiURLs.client.group,
                            successCallback: callback,
                            errorCallback: errCallback
                        }, data);
                    },
                    update: function (data, callback, errCallback, id) {
                        Request.post({
                            method: 'PUT',
                            url: ApiURLs.client.group + '/' + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        }, data);
                    },
                    enable: function (id, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.client.group + '/' + id + '/enable',
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    disable: function (id, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.client.group + '/' + id + '/disable',
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    getAvailableRoles: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.client.groupAvailableRoles,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    }
                },
                Account: {
                    getAll: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.client.account,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    },
                    get: function (id, callback, errCallback) {
                        Request.get({
                            url: ApiURLs.client.account + '/' + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    create: function (data, callback, errCallback) {
                        Request.post({
                            method: 'POST',
                            url: ApiURLs.client.account,
                            successCallback: callback,
                            errorCallback: errCallback
                        }, data);
                    },
                    update: function (data, callback, errCallback, id) {
                        Request.post({
                            method: 'PUT',
                            url: ApiURLs.client.account + '/' + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        }, data);
                    },
                    updatePassword: function (data, callback, errCallback, id) {
                        Request.post({
                            method: 'PUT',
                            url: ApiURLs.client.account + '/' + id + '/password',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, data);
                    },
                    enable: function (id, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.client.account + '/' + id + '/enable',
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    disable: function (id, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.client.account + '/' + id + '/disable',
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    }
                }
            };
        });
})();



// WEBPACK FOOTER //
// ./js/services/ClientService.js